var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M2.97 12.61h29v3.6h-29z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M-.008 13.998 13.993-.003l2.546 2.545L2.538 16.543z","key":1}),React.createElement("path",{"fill":"currentColor","d":"m1.218 15.172 2.546-2.546 12.799 12.799-2.546 2.545z","key":2})]);
}

ArrowLeft.defaultProps = {"viewBox":"0 0 31.97 27.97"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
